import { useLocation, useSearchParams } from "react-router-dom"

let pendingKey = ""
let pendingParams = new URLSearchParams()
export function useUrlState(key: string, fallback = "") {
	const location = useLocation()
	const [params, setParams] = useSearchParams()
	const value = params.get(key) ?? fallback
	const setValue = (next: string) => {
		if (pendingKey !== location.key) {
			pendingKey = location.key
			pendingParams = new URLSearchParams(params)
		}
		const result = new URLSearchParams(pendingParams)
		if (next === fallback || !next) result.delete(key)
		else result.set(key, next)
		pendingParams = result
		setParams(result, { replace: true, preventScrollReset: true })
	}
	return [value, setValue] as const
}
